import { ComponentRef, Directive, inject, Input, ViewContainerRef, OnChanges } from '@angular/core';
import { SpinnerLoaderComponent } from '../components/spinner-loader/spinner-loader.component';


@Directive({
    selector: '[spinnerLoader]'
})
export class SpinnerLoaderDirective implements OnChanges {
  @Input() spinnerLoader!: boolean;
  @Input() size?: string;

  public viewContainerRef = inject(ViewContainerRef);

  spinnerRef!: ComponentRef<any>;

  ngOnChanges(changes: any) {
    for (const key in changes) {
      if (changes.hasOwnProperty(key)) {
        if (key === 'spinnerLoader' && typeof changes[key].currentValue === 'boolean') this.toggleSpinner(changes[key].currentValue);
      }
    }
  }

  toggleSpinner(closed: boolean) {
    if (!closed) {
      this.spinnerRef = this.viewContainerRef.createComponent(SpinnerLoaderComponent);
      this.spinnerRef.instance.size = this.size || '3x';
    } else if (this.spinnerRef) {
      this.spinnerRef.destroy();
    }
  }
}
